// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"01654195","230":"820c0c62","358":"d962c81c"}[chunkId] + ".css";
};